<template>
  <transition name="fade">
    <div :class="$style.wrapper" v-if="show">
      <v-progress-circular
        :class="$style.loader"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
  </transition>
</template>
<script>
export default {
  name: "vc-share-block-progress",
  props: {
    show: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style module scoped>
.wrapper {
  background-color: rgba(255, 255, 255, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 30000;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
